import React from "react";
import useDeviceType from "../../custom-hooks/DeviceType";
import { dummyAvatar, PencilSimpleIcon } from "../../assets";
import EventEHRImageAvatar from "../Atoms/image-avatar/EventEHRImageAvatar";
import TooltipForTable from "../Molecules/tooltip/TooltipForTable";
import { Tooltip } from "@mui/material";

interface PatientDetail {
  label: string;
  value: string;
}

interface EventEHRProfileDetailsCardProps {
  patientDetails: PatientDetail[];
  customColorProperty?: any;
  customImageStyle?: any;
}

const EventEHRProfileDetailsCard = ({
  patientDetails,
  customColorProperty,
  customImageStyle,
}: EventEHRProfileDetailsCardProps) => {
  const deviceType = useDeviceType();

  // ADJUSTED GRID MEANS MADE SCREEN RESPONSIVE
  const adjustedGrid =
    deviceType === "tablet" || deviceType === "small-tablet"
      ? "1fr 1fr"
      : deviceType === "mobile"
        ? "1fr"
        : "1fr 1fr 1fr 1fr";
  const adjustedWidth =
    deviceType === "tablet" ||
    deviceType === "small-tablet" ||
    deviceType === "mobile";

  const campName =
    patientDetails?.find((detail) => detail.label === "Base Camp Admin")
      ?.value || "";

  const fullName =
    patientDetails?.find((detail) => detail.label === "Full Name")?.value || "";

  console.log("patientDetails::", patientDetails);

  //TO SHOW (...)IN ADDRESS FOR FACILITY BASE CAMP
  function truncateString(
    value: string | undefined,
    maxLength: number
  ): String {
    return value && value.length > maxLength
      ? `${value.slice(0, maxLength)}...`
      : value || "";
  }

  return (
    <div
      className="flex justify-center items-start background-color-F1F1F1 border-radius-8px"
      style={{ padding: "20px 28px", gap: "60px", ...customColorProperty }}
    >
      <div
        style={{
          //   width: adjustedWidth ? "15%" : "10%",
          alignSelf: "center",
          ...customImageStyle,
        }}
      >
        {deviceType != "mobile" && (
          <EventEHRImageAvatar
            labelText={fullName ? fullName : campName}
            image={""}
            commonStyle={{
              width: "90px",
              height: "90px",
              border: "2px solid #BCBCBC",
              borderRadius: "8px",
            }}
          />
        )}
      </div>

      <div
        className="patient-details-card"
        style={{
          width: adjustedWidth ? "85%" : "90%",
          display: "grid",
          gridTemplateColumns: adjustedGrid,
          gap: "24px",
        }}
      >
        {patientDetails?.map((data, index) => (
          <div key={index} className="flex flex-col gap-2">
            <div className="font-size-14px font-weight-500 color-727272">
              {data?.label}
            </div>
            <div className="color-393939 font-weight-500">
              {data?.label === "Address" ? (
                <Tooltip arrow title={data?.value}>
                  <span>{truncateString(data?.value, 40)}</span>
                </Tooltip>
              ) : (
                <>{truncateString(data?.value, 40)}</>
              )}
            </div>
          </div>
        ))}
      </div>
      <div>
        {" "}
        {/* EDIT ICON */}
        {/* <img
          className="cursor-pointer"
          src={PencilSimpleIcon}
          alt="edit-icon"
          onClick={() => {}}
        /> */}
      </div>
    </div>
  );
};

export default EventEHRProfileDetailsCard;
